import React, { useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { showToast } from "utils/showToast";
import { placeOrder, toggleListLock } from "store/services/Store/List";
import { useDispatch, useSelector } from "react-redux";
import { lockList, setActiveList } from "store/actions/Store/list";
import { useNavigate } from "react-router-dom";
import { placeOrderMavencery, placeOrderAlHalal } from "assets/svgs";
import { MAVENCERY_STORES_NAMES } from "constants";

const CheckoutForm = ({ placeOrderData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { user } = useSelector((store) => store.userReducer);
  const { activeList } = useSelector((store) => store.storeLists);
  const { comments } = useSelector((store) => store.storeLists);

  const handleLockList = async (lockValue) => {
    const result = await toggleListLock(
      user.accessToken,
      user.data.id,
      selectedStore.id,
      activeList.list_id,
      {
        lock: !lockValue,
      }
    );
    if (result.success) {
      const toogleListLock = { ...activeList, lock: !lockValue };
      dispatch(
        lockList({ list_id: activeList.list_id, newLockStatus: !lockValue })
      );
      dispatch(setActiveList(toogleListLock));
    } else {
      showToast(result.message, "error", false);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);

    const result = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
    });
    setLoading(false);

    if (result.error) {
      showToast(result.error.message, "error", true);
      console.error(result.error.message);
      return;
    }
    const totalAmount = parseFloat(placeOrderData.amount);
    const response = await placeOrder(
      user.accessToken,
      user.data.id,
      selectedStore.id,
      activeList.list_id,
      {
        ...placeOrderData,
        paymentIntentId: result.paymentIntent.id,
        amount: totalAmount,
        comment: comments?.comments,
      }
    );

    if (response.success) {
      showToast("Order Placed Successfully", "success", true);
      navigate(`/stores/${selectedStore.id}/dashboard`);
      handleLockList(activeList.lock);
    } else {
      showToast("Place order failed", "error", true);
    }
  };

  return (
    <div className="flex items-center justify-center h-screen min-h-screen">
      <div
        className={`flex w-full mx-0 bg-white md:mx-3 extraMedium:mx-12 extraMedium:h-2/4 px-0 lg:mx-36 lg:h-4/5 h-4/5 md:h-1/2  ${
          !selectedStore?.isWhiteLabel
            ? "lg:bg-lightBlueColor  md:bg-lightBlueColor"
            : selectedStore?.isWhiteLabel &&
              selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
            ? "lg:bg-lightOrangeColor  md:bg-lightOrangeColor  "
            : "lg:bg-lightBlueColor  md:bg-lightBlueColor"
        }`}
      >
        <div className="flex items-center justify-center w-[100%]  ">
          <div className="flex items-center justify-center w-full px-8 bg-purple-600 cursor-pointer md:px-8 lg:px-0 min-h-96">
            <div
              className={`w-2/4   hidden  md:flex lg:w-[50%] lg:h-[100%] 4xl:h-[100%]  md:h-[100%] md:w-full md:justify-center md:items-center  lg:flex extraMedium:h-full extraMedium:items-start    items-center justify-center font-bold px-8   text-gray-800  `}
            >
              <div className="lg:w-full lg:h-full 4xl:w-[80%] 4xl:h-full md:w-full md:h-full  lg:mt-0  mx-auto">
                <img
                  className="object-contain"
                  src={
                    !selectedStore?.isWhiteLabel
                      ? placeOrderMavencery
                      : selectedStore?.isWhiteLabel &&
                        selectedStore.name ===
                          MAVENCERY_STORES_NAMES.AlHalalMeats
                      ? placeOrderAlHalal
                      : placeOrderMavencery
                  }
                  alt="signup"
                />
              </div>
            </div>
            <div
              className={`md:w-full lg:w-2/5 w-full h-[450px] rounded-md flex  md:flex lg:flex items-center justify-center border bg-lightBlueColor    ${
                !selectedStore?.isWhiteLabel
                  ? "lg:bg-white  md:bg-white "
                  : selectedStore?.isWhiteLabel &&
                    selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
                  ? "lg:bg-white  md:bg-white sm:bg-lightOrangeColor  "
                  : "lg:bg-white  md:bg-white sm:bg-lightBlueColor"
              }   `}
            >
              <form
                onSubmit={handleSubmit}
                className="max-w-md p-4 mx-auto rounded-lg "
              >
                <PaymentElement className="p-2 mb-4 md:bg-white lg:bg-white sm:bg-lightBlueColor " />

                <button
                  type="submit"
                  style={{
                    backgroundColor: selectedStore?.theme.color,
                  }}
                  disabled={!stripe || loading}
                  className={`bg-theme-color hover:bg-lighterPurple text-white ml-3 py-2  px-4 rounded ${
                    loading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                >
                  {loading ? "Submitting..." : `Pay £${placeOrderData?.amount}`}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutForm;
